import { LightEntity } from '@toggle/design-system';
import React from 'react';

import * as S from '../../AssetLogo.styles';
import { FixedIncomeLogo } from '../fixed-income-logo/FixedIncomeLogo';

export interface LogoImageProps {
  entity: LightEntity;
  className?: string;
  logoUrl: string;
  onError: () => void;
  size: number;
  isFiEntity: boolean;
}

export const LogoImage = ({
  entity,
  className,
  logoUrl,
  onError,
  size,
  isFiEntity,
}: LogoImageProps) => {
  const imgProps = {
    src: logoUrl,
    alt: 'logo-image',
    ['data-testid']: 'logo',
    onError,
  };

  return (
    <S.LogoWrapper $size={size} className={className}>
      {isFiEntity ? (
        <FixedIncomeLogo
          imgProps={{ ...imgProps, ['data-testid']: 'fi-logo' }}
          entityTag={entity.tag}
        />
      ) : (
        <img {...imgProps} />
      )}
    </S.LogoWrapper>
  );
};
